import Box from '@mui/material/Box';
import { Button } from '@openx/design-system/components/Button/Button.tsx';
import { useTranslation } from 'react-i18next';
import { OpenXAgentChip } from './OpenXAgentChip.tsx';
import { OpenXAgentChipList, OpenXAgentTitledCard } from './OpenXAgentTitledCard.tsx';
import type { OpenXAgentFilter } from './utils/types.ts';

type OpenXAgentFiltersProps = {
  filters: OpenXAgentFilter[];
  onEditFilters?: (() => void) | undefined;
};

export const OpenXAgentFilters = ({ filters, onEditFilters }: OpenXAgentFiltersProps) => {
  const { t } = useTranslation();

  return (
    <OpenXAgentTitledCard
      title={t('Filters')}
      action={
        <Button variant="text" size="medium" data-test="openx-agent-filters-edit" onClick={onEditFilters}>
          {t('Edit filters')}
        </Button>
      }
    >
      <OpenXAgentChipList>
        {filters.map(({ id, label, value }) => (
          <OpenXAgentChip component="li" key={id} data-test={`openx-agent-filter-${id}`}>
            {label}:{' '}
            <Box component="span" sx={{ fontWeight: 'fontWeightBold' }}>
              {value}
            </Box>
          </OpenXAgentChip>
        ))}
      </OpenXAgentChipList>
    </OpenXAgentTitledCard>
  );
};
